import React from "react";
export default function Link({ value = "", opts = {} }) {
  return (
    <a href={value} target="_blank" className="TUI-Link">
      {opts.name ? opts.name : (value || "").replace(/^.*\/(.*?\..*?)$/, "$1")}
    </a>
  );
}
